import { Injectable } from '@angular/core';
import { LiveFlightEvent } from '../model/liveflight-event';
import { LiveFlight } from '../model/live-flight';
import { ActivityActor } from '../model/activityActor';
import { Actor, ActorMeta } from '../model/actor';
import { DayPilot } from "daypilot-pro-angular";
import { activityAbbreviations } from '../common/enums';
import { Location } from '../model/location';

@Injectable()
export class TooltipService {

  /**
   * Constants
   **/
  readonly TimeChangeWarningThreshold = 10;



  getNumberOfPassengers(flight: LiveFlight) : string {
    // Get the number of passengers
    var pax: string = flight.pax ? flight.pax : "?";
    return pax;
  }

  createAdminBubbleText(activity: ActivityActor, config, location:Location = null): string {

    var start = new DayPilot.Date(activity.start, true).toString("HH:mm");
    var end = new DayPilot.Date(activity.start, true).addMinutes(activity.durationMinutes).toString("HH:mm");

    var activityStatus = activity ? this.statusAbbreviation(activity.state) : "";

    var transferHtml = "";
    if (location) {
      transferHtml += `<tr><td colspan="2"><hr style='padding: 0px; margin: 0px;' />`;
      transferHtml += location.description + "<br>";
        transferHtml += `</td></tr>`
    }

    var time = start +" - "+ end;
    let bgColorClass = "admin";
    let html =
      `<table class="bubble_default_table ` + bgColorClass + `">
      <tbody>
        <tr>
          <td>`+ time + `&nbsp;&nbsp;(<b>` + activityStatus + `</b>)` + `</td>
        </tr>
        ` + transferHtml + `
      </tbody>
    </table>`;
    return html;
  }

  statusAbbreviation(status) {
    var abb = activityAbbreviations.find(x => x.state == status);
    if (abb) {
      return abb.text;
    }
    return "";
  }


  // Create flight-specific HTML text
  createLiveFlightBubbleText(liveFlightEvent : LiveFlightEvent, actor: Actor, config, activity : ActivityActor): string {
    let flight: LiveFlight = liveFlightEvent.liveFlight;
    let arrival = flight.isArrival ? true : false;
    let aircraftType = flight.aircraftExpanded ? flight.aircraftExpanded.iataType : "--";
    var di = flight.diIndicator ? flight.diIndicator : "--";
    var pax = this.getNumberOfPassengers(flight);

    // Determine arrival/departure status
    var status = "--";
    if (arrival) {
      status = flight.arrivalStatus ? flight.arrivalStatusExpanded.flightStatusSwedish[0] : "--";

      // check for final/approach
      var approach;
      if (liveFlightEvent.liveFlight.remarks !== null && liveFlightEvent.liveFlight.remarks !== undefined ){
        approach = liveFlightEvent.liveFlight.remarks.find(x => x.name == "FINALS");
      }
      status = approach ? "Final" : status;


    } else {
      status = flight.departureStatus ? flight.departureStatusExpanded.checkInStatusSwedish : "--";
    }



    let statusText = status ? status : "";

    // Determine probable & scheduled time
    var probtime = "--";
    var schedtime = "";
    probtime = (flight.probableTime ? new Date(flight.probableTime) : new Date(flight.scheduledTime)).toLocaleTimeString(config.locale, { hour: '2-digit', minute: '2-digit' });
    let diff = (flight.probableTime ? new Date(flight.probableTime) : new Date(flight.scheduledTime)).valueOf() - new Date(flight.scheduledTime).valueOf();
    let diffInMin = (diff / 1000) / 60;
    if (diffInMin != 0) {
      let icon = diffInMin >= this.TimeChangeWarningThreshold ? "&nbsp;<span class='material-icons bubble-changed-data'>error</span>" : "";
      schedtime = " (" + new Date(flight.scheduledTime).toLocaleTimeString(config.locale, { hour: '2-digit', minute: '2-digit' }) + ")" + icon;
    }

    let prevGate = (flight.previousGate && flight.gate != flight.previousGate) ? " (" + flight.previousGate + ")&nbsp;<span class='material-icons bubble-changed-data'>error</span>" : "";
    let prevStand = (flight.previousStand && flight.stand != flight.previousStand) ? " (" + flight.previousStand + ")&nbsp;<span class='material-icons bubble-changed-data'>error</span>" : "";

    var coDriversHtml = "";
    var activityStatus = activity ? this.statusAbbreviation(activity.state) : "";

    let meta = actor ? JSON.parse(actor.meta) as ActorMeta : null;
    if (meta && meta.CoDrivers && meta.CoDrivers.length > 1) {
      coDriversHtml += `<tr><td colspan="5"><hr style='padding: 0px; margin: 0px;' />`;
      meta.CoDrivers.forEach(driver => {
        coDriversHtml += driver.Name + `&nbsp(` + driver.BusNumber + `)<br>`
      });
      coDriversHtml += `</td></tr>`
    }
    let bgColorClass = arrival ? "arrival" : "departure";
    if (flight.isRemoteGate) {
      bgColorClass = "departure_remote";
    }
    var activityStatusHtml = `<td></td>`;
    if (activityStatus != "") {
      activityStatusHtml = `<td>Aktivitet</td><td><b>` + activityStatus + `</b></td>`;
    }

    let gate = flight.gate ? flight.gate : "?";
    let stand = flight.stand ? flight.stand : "?";

    let html =
      `<table class="bubble_default_table ` + bgColorClass + `">
      <tbody>
        <tr>
          <td colspan="4"><b>`+ flight.flightNumber + `&nbsp;&nbsp;` + flight.departureDestinationName + "&nbsp;-&nbsp;" + flight.arrivalDestinationName + `</b></td>
        </tr>
        <tr>
          <td>Gate </td><td>` + gate + prevGate + `</td><td>REGN </td><td>` + flight.aircraftRegistration + `</td>
        </tr>
        <tr>
          <td>Stand </td><td>` + stand + prevStand + `</td><td>A/C Type </td><td>` + aircraftType + `</td>
        </tr>
        <tr>
          <td>PAX </td><td>`+ pax + `</td><td>FT </td><td>` + flight.flightServiceTypeIata + `</td>
        </tr>
        <tr>
          <td>DI </td><td>` + di + `</td><td>Ber. tid </td><td>` + probtime + schedtime + `</td>
        </tr>
        <tr>
          <td>Status</td><td colspan="2">` + statusText + `</td>` + activityStatusHtml + `
        </tr>
        ` + coDriversHtml + `
      </tbody>
    </table>`;
    return html;
  }
}
